<section
  class="card-container max_width_page_component"
  [ngClass]="{ to_dashboard_container: isToDashboard() }"
>
  <div class="card-header">
    <div class="card-header-inner">
      @if (!dataIsLoading()) {
        <h3 class="to_dashboard_title">{{ title() }}</h3>
        <p class="hub-section-description">{{ description() }}</p>
      } @else {
        <app-header-loader />
      }
    </div>
  </div>
  <div class="article_container">
    <div
      #scrollContainer
      class="draggable-scroll"
      #scrollable
      (scroll)="updateScrollButtons()"
      (mousedown)="onMouseDown($event)"
      (mousemove)="onMouseMove($event)"
      (mouseup)="onMouseUp()"
      (mouseleave)="onMouseLeave()"
      [ngClass]="{
        displayMode: displayMode() === 'rows' || displayMode() === 'cols',
        gridStyle1: displayMode() === 'grid1',
        gridStyle2: displayMode() === 'grid2',
        gridStyle3: displayMode() === 'grid3',
        gridStyle4: displayMode() === 'grid4',
        'full-width': displayMode() === 'full-width',
      }"
    >
      @if (dataIsLoading()) {
        @for (placeholder of [1, 2]; track placeholder) {
          <app-card-loader />
        }
      }

      @for (entity of entityData(); track getTrackById(entity)) {
        <a
          [routerLink]="generateUrl(entity)"
          [ngClass]="{
            'full-width-link': displayMode() === 'full-width',
            link: isDisabled(),
          }"
        >
          <article
            [style.border-radius]="borderRadius()"
            class="card"
            style="border-radius: 20px"
          >
            @if (entity.imgUrl) {
              <div class="img-container">
                <img
                  class="card-img"
                  [ngSrc]="entity.imgUrl"
                  alt="image"
                  fill=""
                  style="height: 150px"
                />

                @if (entity.viewCount) {
                  <div id="viewCount">
                    <mat-icon>remove_red_eye</mat-icon
                    ><span>{{ entity.viewCount }}</span>
                  </div>
                }
              </div>
            }

            @if (entity.generatedImage) {
              <div class="img-container">
                <img
                  class="card-img"
                  [ngSrc]="entity.generatedImage[0]"
                  alt="image"
                  fill=""
                  style="height: 150px"
                />

                @if (entity.viewCount) {
                  <div class="viewCount">
                    <mat-icon>remove_red_eye</mat-icon
                    ><span>{{ entity.viewCount }}</span>
                  </div>
                }
              </div>
            } @else if (entity?.tips) {
              <div class="img-container tips_placeholder_img_container">
                <img
                  class="card-img tips_placeholder_img"
                  ngSrc="/assets/svg/logo-inverted.png"
                  alt="image"
                  width="100"
                  height="150"
                />

                @if (entity.viewCount) {
                  <div class="viewCount">
                    <mat-icon>remove_red_eye</mat-icon
                    ><span>{{ entity.viewCount }}</span>
                  </div>
                }
              </div>
            }

            <div
              class="card-body"
              [ngClass]="{
                tips_card_body: $safeNavigationMigration(entity?.tips),
              }"
            >
              @if (entity.publish_date || entity.date) {
                <div class="meta">
                  <p>
                    {{
                      entity?.publish_date || entity?.date
                        | date: 'd. MMM, yyyy'
                    }}
                  </p>

                  <p>
                    {{ 'PAGES.HUB.READING_TIME' | translate }}
                    {{ entity?.readingTimeStats?.minutes?.toFixed(0) }} min.
                  </p>
                </div>
              }
              <h3
                [ngClass]="{
                  tips_header: $safeNavigationMigration(entity?.tips),
                }"
              >
                {{ entity.title || entity?.int }}
              </h3>

              <p class="desc">
                {{
                  entity.description ||
                    entity?.content?.sub_header ||
                    entity?.meta_description ||
                    entity?.mT ||
                    entity?.hub?.metaDesc ||
                    entity?.descTag
                }}
              </p>
            </div>
          </article>
        </a>
      }
      @if (isTipsAndTricks()) {
        <a
          [href]="tipsIndexLink()"
          [ngClass]="{
            'full-width-link': displayMode() === 'full-width',
            link: isDisabled(),
          }"
        >
          <article
            [style.border-radius]="borderRadius()"
            class="card"
            style="border-radius: 20px"
          >
            <div class="card-body" [ngClass]="'/' + { tips_card_body: true }">
              <h3 [ngClass]="{ tips_header: true }">
                {{ 'COMPONENTS.GENERIC_CARD.SEE_ALL_TIPS' | translate }}
              </h3>
            </div>
          </article>
        </a>
      }
    </div>

    @if (showLeft() && entityData() && entityData().length > 1) {
      <button class="scroll_button left" (click)="scrollLeft()">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>
    }

    @if (showRight() && entityData() && entityData().length > 1) {
      <button class="scroll_button right" (click)="scrollRight()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    }
  </div>
</section>
